// extracted by mini-css-extract-plugin
module.exports = {"addressLabelWrapper":"styles_addressLabelWrapper__OVYYo","countryFlagWrapper":"styles_countryFlagWrapper__2z1U6","labelWrapper":"styles_labelWrapper__26ghS"};